export default {"src":"/_next/static/media/bell-classic-solid.8c923b35.svg","height":24,"width":24};